import {
  Box,
  Button,
  Container,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Grid,
  Link,
  Paper,
  Typography
} from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function BlogDetail() {
  const { id } = useParams(); // Capture the id from the URL
  const navigate = useNavigate(); // For redirecting after deletion
  const [post, setPost] = useState(null);
  const [openDialog, setOpenDialog] = useState(false); // State for dialog

  useEffect(() => {
    if (id) {
      axios
        .get(`https://ipms.insollex.com/api/post/${id}`)
        .then((response) => {
          setPost(response.data);
        })
        .catch((error) => {
          console.error('Error fetching post:', error);
        });
    } else {
      console.error('Post ID is undefined. Check the URL and route configuration.');
    }
  }, [id]);

  const handleDelete = () => {
    axios
      .delete(`https://ipms.insollex.com/api/post/${id}`)
      .then(() => {
        alert('Post deleted successfully');
        navigate(-1); // Redirect to the previous page
      })
      .catch((error) => {
        console.error('Error deleting post:', error);
      });
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  if (!post) {
    return (
      <Container>
        <Typography variant="h6" align="center" sx={{ mt: 5 }}>
          Loading...
        </Typography>
      </Container>
    );
  }

  return (
    <Container>
      <Box sx={{ marginTop: 4 }}>
        {/* Title */}
        <Typography variant="h3" align="center" gutterBottom>
          {post.title || 'Untitled Post'}
        </Typography>

        {/* Meta Information */}
        <Typography variant="subtitle1" align="center" sx={{ color: 'text.secondary', marginBottom: 3 }}>
          {post.createdAt
            ? `Published on ${new Date(post.createdAt).toLocaleDateString()}`
            : 'Publication date unavailable'}
        </Typography>

        {/* Image */}
        {post.image && (
  <Box sx={{ marginBottom: 3, maxWidth: 400, mx: 'auto' /* center horizontally */ }}>
    <Paper elevation={3} sx={{ overflow: 'hidden', borderRadius: 2 }}>
      <img
        src={`https://ipms.insollex.com${post.image.startsWith('/') ? '' : '/'}${post.image}`}
        alt={post.title || 'Post Cover'}
        style={{
          display: 'block',
          width: '100%',
          height: 'auto',
          opacity: 0.6,           // makes it faded (60% opacity)
          borderRadius: 8,        // optional: rounded corners to soften the image edges
          objectFit: 'cover',     // ensure it covers nicely inside box
        }}
      />
    </Paper>
  </Box>
)}

        {/* Content */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} sx={{ mx: 'auto' }}>
            <Typography variant="body1" sx={{ textAlign: 'justify', lineHeight: 1.8 }}>
              {post.content || 'No content available for this post.'}
            </Typography>
          </Grid>
        </Grid>

        {/* URL Section */}
        {post.url && (
          <Box sx={{ textAlign: 'center', marginTop: 4 }}>
            <Typography variant="subtitle1" sx={{ color: 'text.secondary', mb: 1 }}>
              Related URL:
            </Typography>
            <Link href={post.url} target="_blank" rel="noopener noreferrer" variant="body1">
              {post.url}
            </Link>
          </Box>
        )}

        {/* Buttons Section */}
        <Box sx={{ textAlign: 'center', marginTop: 4 }}>
          <Button variant="contained" color="primary" size="large" onClick={() => navigate(-1)} sx={{ mr: 2 }}>
            Go Back
          </Button>
          <Button variant="contained" color="error" size="large" onClick={handleOpenDialog}>
            Delete Post
          </Button>
        </Box>

        {/* Confirmation Dialog */}
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this post?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Cancel
            </Button>
            <Button onClick={handleDelete} color="error">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Container>
  );
}
